import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=6c8ce0f6&scoped=true&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ce0f6",
  null
  
)

export default component.exports